import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { LoanSummaryCard, WarningModal } from "../../../components";
import { loanRefinance } from "../../../services";
import payrollFrequency from "../../../mocks/payrollFrequency.json";
import {
  LOAN_MODIFICATION_TYPE,
  distributionFormFields,
  getKeyByValue,
} from "../../../utils";
import LoanRefinanceRequest from "../../Transaction/LoanRequestsPendingApprovalContainer/LoanRefinanceRequest/LoanRefinanceRequest";
import AmortizationSchedule from "./AmortizationSchedule/AmortizationSchedule";
import { appLayoutStore, globalToastInfo } from "../../../contexts";
import { useContext } from "react";

const minimumLength = [
  {
    label: 3,
    value: 1,
  },
  {
    label: 6,
    value: 2,
  },
  {
    label: 12,
    value: 3,
  },
];
const LoanSummarySlider = ({
  loanData,
  planData,
  loanSettingInfo,
  employeeInfo,
  modifyFor,
  principalPaid,
  calculateTotalNoOfInstallments,
  isReFinancing = false,
  setSliderOpen2,
  setTrigger,
  loanStatus,
  trigger,
  repaymentSchedule,
}) => {
  isReFinancing = modifyFor == "loanRefinancing" ? true : false;
  const initialReamortizeValues = {
    tenureYears: loanData.tenureYears,
    tenureMonths: loanData.tenureMonths,
    transactionFees: loanSettingInfo?.loanReAmortizationFee,
    periodicPaymentAmount: loanData.periodicPaymentAmount,
    repaymentMethod: loanData.repaymentMethod ?? 2,
    repaymentFrequency: loanData.repaymentFrequency ?? null,
  };

  const initialRefinancingValues = {
    loanAmount: 0,
    interestRate: loanData.interestRate,
    tenureYears: loanData.tenureYears,
    tenureMonths: loanData.tenureMonths,
    transactionFees: loanSettingInfo?.loanRefinancingFee,
    repaymentMethod: loanData.repaymentMethod ?? 2,
    repaymentFrequency: loanData.repaymentFrequency ?? null,
  };

  const reFinancingValidationSchema = Yup.object({
    loanAmount: Yup.number().required("Required").nullable(),
    interestRate: Yup.number().required("Required").nullable(),
    tenureYears: Yup.number().required("Required").nullable(),
    tenureMonths: Yup.number().required("Required").nullable(),
    transactionFees: Yup.number().required("Required").nullable(),
  });
  const reReamortizationValidationSchema = Yup.object({
    tenureYears: Yup.number().required("Required").nullable(),
    tenureMonths: Yup.number().required("Required").nullable(),
    transactionFees: Yup.number().required("Required").nullable(),
    periodicPaymentAmount: Yup.number()
      .required("Required")
      .min(1, "Periodic Payment Amount should be greater than 0")
      // .max(loanData.loan
      .nullable(),
    // repaymentFrequency: Yup.number().required("Required").nullable(),
  });
  const loanId = loanData.id;
  const loanType = loanSettingInfo.loanDescription;
  const { state: state2, dispatch: dispatch2 } = useContext(appLayoutStore);
  const [modalVisible, setModalVisible] = useState(false);
  const [loanRemaningAmount, setLoanRemaningAmount] = useState(0);
  const [periodicPaymentVal, setPeriodicPaymentVal] = useState(
    loanData.periodicPaymentAmount
  );
  const [noOfInstallments, setNoOfInstallments] = useState(0);
  const [firstDate, setFirstDate] = useState(new Date());
  //   const formName = manageDistributionFormName.LOAN_REFINANCE_REQUEST;
  //   const fields = distributionFormFields[formName];
  const submitmessage = () => {
    if (isReFinancing)
      return "Loan Refinance request was successfully submitted for";
    else return "Loan Reamortization request was successfully submitted for";
  };
  const onFormSubmit = (values) => {
    const updatedValues = {
      loanId: loanId,
      loanAmount: isReFinancing ? values.loanAmount ?? null : 0,
      interestRate: isReFinancing
        ? values.interestRate ?? null
        : loanData.interestRate ?? null,
      tenureYears: values.tenureYears ?? null,
      tenureMonths: values.tenureMonths ?? null,
      repaymentFrequency: values.repaymentFrequency ?? null,
      repaymentMethod: values.repaymentMethod ?? null,
      periodicPaymentAmount: !isReFinancing
        ? values.periodicPaymentAmount ?? null
        : periodicPaymentVal ?? null,
      transactionFees: values.transactionFees ?? null,
      modificationType: isReFinancing
        ? parseInt(getKeyByValue(LOAN_MODIFICATION_TYPE, "ReFinance"))
        : parseInt(getKeyByValue(LOAN_MODIFICATION_TYPE, "ReAmortize")),
    };

    loanRefinance(updatedValues).then((res) => {
      dispatch2(
        globalToastInfo({
          showToast: true,
          toastMessage: submitmessage() + " " + loanType + "-" + loanId,
        })
      );
      setSliderOpen2(false);
      setTrigger(!trigger);
    });
  };
  const loanRefinancebool = true;
  return (
    <div>
      <Formik
        initialValues={
          isReFinancing ? initialRefinancingValues : initialReamortizeValues
        }
        onSubmit={onFormSubmit}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={
          isReFinancing
            ? reFinancingValidationSchema
            : reReamortizationValidationSchema
        }
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            errors,
            handleBlur,
            ...rest
          } = formProps;

          const valuesSentToRepaymentSchedule = {
            loanRequestAmount: loanRemaningAmount,
            tenureYears: values.tenureYears,
            tenureMonths: values.tenureMonths,
            periodicPaymentAmount: periodicPaymentVal,
            repaymentFrequency: loanData.repaymentFrequency,
            interestRate: loanData.interestRate,
            loanStatus: loanData.loanStatus,
            firstRepaymentDate: firstDate,
          };

          if (isReFinancing) {
            valuesSentToRepaymentSchedule.loanRequestAmount =
              values.loanAmount + loanRemaningAmount;
            valuesSentToRepaymentSchedule.interestRate = values.interestRate;
          } else {
            if (
              values.repaymentMethod == 1 &&
              ![null, undefined, ""].includes(values.repaymentFrequency)
            ) {
              valuesSentToRepaymentSchedule.repaymentFrequency =
                values.repaymentFrequency;
            }
            if (![null, undefined, ""].includes(values.periodicPaymentAmount))
              valuesSentToRepaymentSchedule.periodicPaymentAmount =
                values.periodicPaymentAmount;
          }
          return (
            <div style={{ height: "100%", overflow: "hidden" }}>
              <Form>
                <div className="d-flex justify-content-between align-baseline">
                  <div className="plan-heading font-weight-500">
                    {isReFinancing ? (
                      <>Loan Refinance Request</>
                    ) : (
                      <>Loan Reamortize Request</>
                    )}
                  </div>{" "}
                  <div className="d-flex mt-10">
                    <Button
                      variant={"secondary"}
                      onClick={() => setModalVisible(true)}
                    >
                      Cancel
                    </Button>
                    <div className={"ml-3"}>
                      <Button
                        type="submit"
                        // onClick={() => {
                        //  // onFormSubmit(values);
                        //  // setSliderOpen2(false);
                        // }}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>{" "}
                {/* <button type="submit">Submiiiit</button> */}
                <div style={{}}>
                  <LoanSummaryCard
                    loanData={loanData}
                    planData={planData}
                    loanSettingInfo={loanSettingInfo}
                    employeeInfo={employeeInfo}
                    principalPaid={principalPaid}
                    calculateTotalNoOfInstallments={
                      calculateTotalNoOfInstallments
                    }
                  />

                  <div
                    style={{
                      fontWeight: "500",
                      marginTop: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    Loan Calcuator
                  </div>
                  <div
                    style={{
                      backgroundColor: "#ECECEC",
                      padding: "8px 16px",
                      height: "38px",
                      borderRadius: "6px",
                    }}
                  >
                    {" "}
                    <FontAwesomeIcon
                      className="mr-2 ft-14"
                      style={{ color: "#444446" }}
                      icon={faInfoCircle}
                    />
                    {isReFinancing ? (
                      <>
                        You are allowed to Modify Loan Amount, Interest rate or
                        tenure
                      </>
                    ) : (
                      <>
                        You are allowed to modify Periodic payment, repayment
                        frequency or tenure
                      </>
                    )}
                  </div>
                </div>
                <div style={{ marginTop: "10px", overflowY: "scroll" }}>
                  <Row>
                    <Col md={6}>
                      <LoanRefinanceRequest
                        isReFinancing={isReFinancing}
                        loanData={loanData}
                        planData={planData}
                        loanSettingInfo={loanSettingInfo}
                        setLoanRemaningAmount={setLoanRemaningAmount}
                        setPeriodicPaymentVal={setPeriodicPaymentVal}
                        periodicPaymentVal={periodicPaymentVal}
                        setFirstDate={setFirstDate}
                        setNoOfInstallments={setNoOfInstallments}
                        repaymentSchedule={repaymentSchedule}
                      />
                    </Col>
                    <Col md={6}>
                      {console.log(
                        "kiran values",
                        valuesSentToRepaymentSchedule
                      )}
                      <AmortizationSchedule
                        loanData={valuesSentToRepaymentSchedule}
                        loanRefinancebool={loanRefinancebool}
                        loanStatus={loanStatus}
                        noOfInstallments={noOfInstallments}
                      />
                      {console.log("noOfInstallments", noOfInstallments)}
                    </Col>
                  </Row>
                </div>
              </Form>
              <WarningModal
                show={modalVisible}
                onHide={() => setModalVisible(false)}
              >
                <div className="remove-text">
                  <h4>Are you sure you want to go back?</h4>

                  <Button
                    className="remove-btn mr-4"
                    onClick={() => {
                      setModalVisible(false);
                      setSliderOpen2(false);
                    }}
                  >
                    Yes
                  </Button>

                  <Button
                    className="cancel-btn"
                    onClick={() => setModalVisible(false)}
                  >
                    No
                  </Button>
                </div>
              </WarningModal>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default LoanSummarySlider;
